import { createFileRoute } from "@tanstack/react-router";
import GeoUSA from "@/pages/GeoUSA";
import {
  buildPageHead,
  breadcrumbSchema,
  serviceSchema,
  faqPageSchema,
} from "@/lib/seo";

const faqs = [
  {
    question: "Can I hire a technical VA from the Philippines for a US agency?",
    answer:
      "Yes. Marjohn is a Philippines-based technical virtual assistant with EST/PST timezone overlap for US-based agencies, hired directly as a contractor without agency markups or middleman fees.",
  },
  {
    question: "Why hire a technical VA from the Philippines for the USA?",
    answer:
      "Hiring from the Philippines gives US agencies senior-grade CRM and automation support at a fraction of local rates, with direct contractor engagement, EST/PST timezone overlap, and no agency markups.",
  },
  {
    question: "How much does it cost to hire a technical VA for the USA?",
    answer:
      "Engagements are scoped per project or retainer. Marjohn works as a remote contractor paid via low-fee cross-border transfers such as Wise. Book a free strategy call to receive a custom scope and quote.",
  },
  {
    question: "What timezone overlap do you offer with the USA?",
    answer:
      "Marjohn offers seamless overlap with both EST (New York) and PST (Los Angeles) business hours, so US agencies get real-time collaboration during their working day.",
  },
];

export const Route = createFileRoute("/hire-technical-va-usa")({
  head: () =>
    buildPageHead({
      title: "Hire Technical VA in USA | Marjohn Robillo",
      description:
        "Hire an elite Technical Virtual Assistant from the Philippines for your US-based agency. Seamless EST/PST timezone overlap and direct hiring without agency markups.",
      path: "/hire-technical-va-usa",
      keywords:
        "hire technical VA USA, technical virtual assistant Philippines, US agency VA, EST timezone VA, direct hire VA Philippines, CRM automation VA USA",
      hreflang: [
        {
          hreflang: "en-US",
          href: "https://marjohnrobillo.me/hire-technical-va-usa",
        },
        {
          hreflang: "en-GB",
          href: "https://marjohnrobillo.me/revops-specialist-uk",
        },
        {
          hreflang: "en-AU",
          href: "https://marjohnrobillo.me/ghl-automation-expert-australia",
        },
        { hreflang: "x-default", href: "https://marjohnrobillo.me/" },
      ],
      schema: [
        serviceSchema({
          name: "Technical Virtual Assistant for US Agencies",
          description:
            "Direct-hire technical VA from the Philippines with EST/PST timezone overlap for US-based agencies.",
          path: "/hire-technical-va-usa",
          serviceType: [
            "Technical Virtual Assistant",
            "CRM Operations",
            "Automation Support",
          ],
          areaServed: ["United States", "Canada"],
        }),
        breadcrumbSchema([
          { name: "Home", path: "" },
          { name: "Hire Technical VA (USA)", path: "/hire-technical-va-usa" },
        ]),
        faqPageSchema(faqs),
      ],
    }),
  component: GeoUSA,
});
